import { useState, useCallback } from "react";
import { TimeDisplayMode } from "../utils/DateFormatter";
import { SafeStorage } from "../utils/SafeStorage";

const STORAGE_KEY = "abrc.timeDisplayMode";

const readStoredMode = (): TimeDisplayMode => (SafeStorage.get(STORAGE_KEY) === "utc" ? "utc" : "local");

export const useTimeDisplayMode = (): [TimeDisplayMode, (mode: TimeDisplayMode) => void] => {
  const [mode, setModeState] = useState<TimeDisplayMode>(readStoredMode);

  const setMode = useCallback((next: TimeDisplayMode): void => {
    setModeState(next);
    SafeStorage.set(STORAGE_KEY, next);
  }, []);

  return [mode, setMode];
};
